import { TreeService } from 'business/services/TreeService';
import { BaseTreeDataSupplier } from './BaseTreeDataSupplier';

class WizardTreeDataSupplier implements BaseTreeDataSupplier {
  async getTreeNodes(id: any) {
    const ser: TreeService = new TreeService();
    const children = await ser.getWizardTreeNodesService(id);

    if (children === null) {
      return null;
    }

    return children;
  }
}

export default WizardTreeDataSupplier;
